import React from "react";
import PropTypes from "prop-types";
import AttributeFilterModalContent from "components/source/new_taxonomy/attribute-filter-modal-content";
import ClosableModal from "components/source/shared/closable-modal";
import Constants from "rtr-constants";

const propTypes = {
  displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  expandFilters: PropTypes.func.isRequired,
  renderRTRFilters: PropTypes.func.isRequired,
  filterOptions: PropTypes.object.isRequired,
  isFilterOpen: PropTypes.func.isRequired,
  onToggleOpenFilters: PropTypes.func.isRequired,
  openFilters: PropTypes.array,
  onRequestClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  workingFilters: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  clearAttributeFilters: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitFilters: PropTypes.func.isRequired,
  onChangeSort: PropTypes.func,
  selectedSort: PropTypes.string,
  isHomeGoodGrid: PropTypes.bool,
  renderSpecialFields: PropTypes.func,
  getFieldsetHeader: PropTypes.func,
  isDeadEndTextSearch: PropTypes.bool,
  isMobileViewport: PropTypes.bool,
  showLimitedFilterSet: PropTypes.bool,
  showSizeFilter: PropTypes.bool,
  pathInfo: PropTypes.object,
};

const defaultProps = {
  openFilters: [
    Constants.filters.canonicalSizes,
    Constants.filters.colors,
    Constants.filters.formality,
    Constants.filters.length,
  ],
  errors: {},
};

export default class FilterModal extends React.Component {
  constructor(props) {
    super(props);
    this.className = "FilterModal";
    this.modalName = "filter-modal";
    const desktopStyles = {
      maxWidth: "45%",
      inset: "auto 0 auto auto",
      transform: "unset",
    };
    this.styles = {
      content: {
        padding: 0,
        height: "100%",
        ...(!this.props.isMobileViewport && desktopStyles),
      },
    };
  }

  render() {
    return (
      <div data-test-id="filter-modal">
        {this.props.displayedModal === this.modalName && (
          // TODO: is this props spread ok?
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ClosableModal optionalClass={this.className} additionalStyles={this.styles} isOpen={true} {...this.props}>
            <AttributeFilterModalContent
              closeModal={this.props.onRequestClose}
              onApply={this.props.onApply}
              displayedModal={this.props.displayedModal}
              errors={this.props.errors}
              filters={this.props.filters}
              workingFilters={this.props.workingFilters}
              filterOptions={this.props.filterOptions}
              isFilterOpen={this.props.isFilterOpen}
              onChange={this.props.onFilterChange}
              onClearFilters={this.props.clearAttributeFilters}
              submitFilters={this.props.submitFilters}
              onToggleOpenFilters={this.props.onToggleOpenFilters}
              openFilters={this.props.openFilters}
              renderRTRFilters={this.props.renderRTRFilters}
              renderSpecialFields={this.props.renderSpecialFields}
              getFieldsetHeader={this.props.getFieldsetHeader}
              onChangeSort={this.props.onChangeSort}
              selectedSort={this.props.selectedSort}
              isHomeGoodGrid={this.props.isHomeGoodGrid}
              isDeadEndTextSearch={this.props.isDeadEndTextSearch}
              expandFilters={this.props.expandFilters}
              showLimitedFilterSet={this.props.showLimitedFilterSet}
              showSizeFilter={this.props.showSizeFilter}
            />
          </ClosableModal>
        )}
      </div>
    );
  }
}

FilterModal.propTypes = propTypes;
FilterModal.defaultProps = defaultProps;
